import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3f8c2559&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3f8c2559&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8c2559",
  null
  
)

/* custom blocks */
import block0 from "./index.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./index.vue?vue&type=custom&index=1&blockType=router"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteVideosShow: require('/home/ubuntu/nuxt/bonkers/releases/20230320152633/components/site/videos/show.vue').default,SiteBlogCategories: require('/home/ubuntu/nuxt/bonkers/releases/20230320152633/components/site/blog/categories.vue').default,SiteVideosList: require('/home/ubuntu/nuxt/bonkers/releases/20230320152633/components/site/videos/list.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230320152633/components/site/feefo.vue').default})
